import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { green, red } from '@mui/material/colors'

interface ICheckIconProps {
  check?: boolean
}

const useStyles = makeStyles(() => ({
  CheckBox: {
    color: green[500],
    height: '12px',
    position: 'absolute',
    right: '-8px',
    top: '-5px',
  },
  UnCheckBox: {
    color: red[500],
    height: '12px',
    position: 'absolute',
    right: '-8px',
    top: '-5px',
  },
}))

const CheckIcon: React.FC<ICheckIconProps> = (props) => {
  const classes = useStyles()
  const check = props.check
  return (
    <>
      {check && <CheckCircleIcon className={classes.CheckBox} />}
      {!check && <CancelIcon className={classes.UnCheckBox} />}
    </>
  )
}

export default CheckIcon
